import script from "./app-channel.vue?vue&type=script&setup=true&lang=js"
export * from "./app-channel.vue?vue&type=script&setup=true&lang=js"

import "./app-channel.vue?vue&type=style&index=0&id=09148bde&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09148bde"]])

export default __exports__